import type { AuthorityToDeal } from '@agria/paws/src/types';

/**
 * Compares two AuthorityToDeal objects for equality.
 * Returns true if they represent the same additional policy holder.
 */
export const areAdditionalPolicyHoldersEqual = (
  existing: Partial<AuthorityToDeal> | null | undefined,
  incoming: Partial<AuthorityToDeal> | null | undefined,
): boolean => {
  if (!existing && !incoming) return true;
  if (!existing || !incoming) return false;

  if (Array.isArray(existing) || Array.isArray(incoming)) {
    console.warn(
      '⚠️ Additional policy holder should be single object, not array',
    );
    return false;
  }

  return (
    existing.TitleId === incoming.TitleId &&
    existing.FirstName === incoming.FirstName &&
    existing.LastName === incoming.LastName &&
    existing.Email === incoming.Email &&
    existing.DateOfBirth === incoming.DateOfBirth &&
    existing.AddressSameAsMain === incoming.AddressSameAsMain
  );
};
